import styled from 'styled-components';
import {useFormContext} from 'react-hook-form';

import Label from 'components/Label';
import Textbox from 'components/Textbox';
import FileUpload from 'components/FileUpload';
import Textarea from 'components/Textarea';

const Container = styled.div`
  display: grid;
  grid-template-areas: 'name photo'
                       'quote quote'
                       'remove remove';
  grid-template-columns: 1fr 1fr;
  gap: 16px 20px;
  background: ${({theme}) => theme.group.bg};
  border: ${({theme}) => theme.group.border};
  padding: 24px;
  border-radius: 12px;
`;

const GridLabel = styled(Label)`
  grid-area: ${({$area}) => $area};
`;

const Remove = styled.div`
  grid-area: remove;
  text-align: right;
  text-decoration: underline;
  cursor: pointer;
  color: ${({theme}) => theme.label.description};
`;

const Testimonial = ({
  name, rules, onRemove,
}) => {
  const {register} = useFormContext();

  return (
    <Container>
      <GridLabel title="Name" $area="name">
        <Textbox
          name={`${name}.name`}
          ref={register(rules)}
          placeholder="e.g., Jean-luc Picard"
        />
      </GridLabel>
      <GridLabel title="Photo" $area="photo">
        <FileUpload
          actionLabel="Select Image"
          name={`${name}.photo`}
          ref={register(rules)}
        />
      </GridLabel>
      <GridLabel title="Quote" $area="quote">
        <Textarea
          name={`${name}.quote`}
          ref={register(rules)}
          placeholder="e.g., Pretty good, not great!"
          rows={3}
        />
      </GridLabel>
      <Remove onClick={onRemove}>
        Remove Testimonial
      </Remove>
    </Container>
  );
};

export default Testimonial;
